var ItemBase = /** @class */ (function () {
    function ItemBase(options) {
        if (options === void 0) { options = {}; }
        this.value = options.value;
        this.key = options.key || '';
        this.label = options.label || '';
        this.required = !!options.required;
        this.controlType = options.controlType || '';
        this.readonly = !!options.readonly;
        this.hidden = !!options.hidden;
    }
    return ItemBase;
}());
export { ItemBase };
export var DataType;
(function (DataType) {
    DataType.int32 = 'int32';
    DataType.int64 = 'int64';
    DataType.float = 'float';
    DataType.double = 'double';
    DataType.byte = 'byte';
    DataType.binary = 'binary';
    DataType.date = 'date';
    DataType.date_time = 'date-time';
    DataType.password = 'password';
})(DataType || (DataType = {}));
//# sourceMappingURL=item-base.js.map